(function () {
    var model = angular.module('managementModule', ['ngDraggable']);

    model.controller(controllers.manageFavoritesController, ['$scope', '$http', '$state', '$uibModal', '$uibModalInstance', 'broadcastService', 'items', 'pubSub', '$q', 'configService',
        function ($scope, $http, $state, $uibModal, $modalInstance, broadcastService, items, pubSub, $q, configService) {
            $scope.translation = globalResources;
            $scope.folders = [];
            $scope.forcedAndDepartmentFolders = [];
            $scope.originalFoldersData = [];
            $scope.documents = [];
            $scope.originalDocumentsData = [];
            $scope.emailSubsribed = [];
            $scope.manageFavoriteTabs = manageFavoriteTabs;
            $scope.currentTab = manageFavoriteTabs.folder;
            $scope.isChanged = false;
            $scope.isSortByAlphabet = true;
            $scope.runOnce = false;
            $scope.areas = [];
            $scope.processes = [];
            $scope.showSort = $scope.currentTab !== manageFavoriteTabs.emailSubscribed;

            $scope.simpleSubscription = configService.getBool(HandbookConfiguration.SimpleSubscription);
            $scope.enableProcessModule = configService.getBool(HandbookConfiguration.EnableProcess);

            initDataSource();

            $scope.loadEmailSubscribedFolder = function () {
                if ($scope.enableProcessModule) {
                     $http.get('/api/CombineDocumentAndProcess/GetUserEmailSubscriptionsForDocumentAndProcess')
                        .then(function (res) {
                            if (res) {
                                var items = []
                                items = res.data;
                                items.forEach(function (item) {
                                    if (checkFolder(item.type) || item.isProcessArea) {
                                        if (item.isRecursiveFolder) {
                                            item.subscriptionName = $scope.translation.FolderAndSubFolders;
                                        } else {
                                            item.subscriptionName = $scope.translation.FolderOnly;
                                        }
                                    }
                                });
                                $scope.emailSubsribed = items;
                            }
                        });
                    return;
                }
               
                $http.get(handbookRequests.GetUserEmailSubscriptionsForFoldersAndDocuments)
                     .then(function (result) {
                         result.data.forEach(function (item) {
                             if (checkFolder(item.type)) {
                                 if (item.isRecursiveFolder) {
                                     item.subscriptionName = $scope.translation.FolderAndSubFolders;
                                 } else {
                                     item.subscriptionName = $scope.translation.FolderOnly;
                                 }
                             }
                         });
                         $scope.emailSubsribed = result.data;
                     })
            };

            function checkFolder(type){
                if(type == E.nodeTypes.Folder || type == E.nodeTypes.TopFolder || type == E.nodeTypes.DepartmentFolder || type == E.nodeTypes.RegionalFolder){
                    return true;
                }
                return false;
            }

            $scope.removeAreaFromFavorites = function (area) {
                var params = {
                    areaId: area.id
                }
                var requestUrl = handbookRequests.RemoveAreaFromFavoritesRequest;
                confirmAndDeleteItem(area, requestUrl, $scope.areas, null, true, params);
            };

            $scope.removeProcessFromFavorites = function (process) {
                var params = {
                    processId: process.processId
                };
                var requestUrl = "/api/ProcessAreas/RemoveProcessFromFavorites/" + params;
                confirmAndDeleteItem(process, requestUrl, $scope.processes, null, true, params);
            };

            $scope.removeFolderFromFavorite = function (folder) {
                var requestUrl = handbookRequests.RemoveFavoriteFolder + '/' + folder.id;
                confirmAndDeleteItem(folder, requestUrl, $scope.folders, $scope.originalFoldersData, true);
            };

            $scope.removeDocumentFromFavorite = function (document) {
                var requestUrl = handbookRequests.RemoveFavoriteDocument + '/' + document.id;
                confirmAndDeleteItem(document, requestUrl, $scope.documents, $scope.originalDocumentsData, true);
            };

            $scope.removeEmailSubscribed = function (folder) {
                var requestUrl = '';
                var params;
                if (folder.isProcess) {
                    requestUrl = handbookRequests.RemoveProcessEmailSubscription;
                    params = { ProcessId: folder.id };
                    confirmAndDeleteItem(folder, requestUrl, $scope.emailSubsribed, null, false, { ProcessId: folder.id });
                    return;
                }
                else if (folder.isProcessArea) {
                    params = { AreaId: folder.id };
                    if (folder.isRecursiveFolder) {
                        requestUrl = handbookRequests.RemoveAreaAndItsChildrenFromEmailSubscription;
                    }
                    else {
                        requestUrl = handbookRequests.RemoveOnlyAreaFromEmailSubscription;
                    }
                    confirmAndDeleteItem(folder, requestUrl, $scope.emailSubsribed, null, false, { AreaId: folder.id });
                    return;
                }
                else if (checkFolder(folder.type)) {
                    params = false;
                    if (folder.isRecursiveFolder) {
                        requestUrl = handbookRequests.RemoveEmailSubscription + '/' + folder.id;
                    } else {
                        requestUrl = handbookRequests.RemoveOnlyFolderFromEmailSubscription + '/' + folder.id;
                    }
                } else {
                    params = false;
                    requestUrl = handbookRequests.RemoveEmailSubscriptionDocument + '/' + folder.id;
                }
                confirmAndDeleteItem(folder, requestUrl, $scope.emailSubsribed, null, false);
            };

            $scope.onDragSuccess = function (data, evt) {
                $scope.runOnce = false;
            };

            $scope.onDropComplete = function (index, obj, evt, isProcessAreaItem) {
                if (!$scope.runOnce) { // to prevent this evt run twice
                    $scope.isChanged = true;
                    var dataSource = isProcessAreaItem ? getSourceProcessAreasByItemType(obj.type) : getSourceByItemType(obj.type);
                    removeBorderAndUpdateOrder(index, evt.element, obj, dataSource, false, false);
                }
            }

            $scope.onDropCompleteForLastItem = function (index, obj, evt, isProcessAreaItem) {
                $scope.isChanged = true;
                var dataSource = isProcessAreaItem ? getSourceProcessAreasByItemType(obj.type) : getSourceByItemType(obj.type);
                removeBorderAndUpdateOrder(index, evt.element, obj, dataSource, false, true);
            }

            $scope.onDropCompleteForTopItem = function (index, obj, evt, isProcessAreaItem) {
                $scope.isChanged = true;
                var dataSource = isProcessAreaItem ? getSourceProcessAreasByItemType(obj.type) : getSourceByItemType(obj.type);
                removeBorderAndUpdateOrder(index, evt.element, obj, dataSource, true, false);
            }

            $scope.setCurrentTab = function (tab) {
                $scope.currentTab = tab;
                $scope.showSort = $scope.currentTab !== manageFavoriteTabs.emailSubscribed;
            };

            $scope.addCurrentActiveClass = function (id) {
                removeOldActiveDragItem();
                angular.element(prefix.hashbangPrefix + id).addClass(cssClass.currentDrag);
            };

            $scope.sortAlphabet = function () {
                if (!$scope.isSortByAlphabet) {
                    $scope.isChanged = true;
                    var source = getSourceByCurrentTab(false);
                    setOrderByAlphabet(source);
                }
            };

            $scope.cancel = function () {
                $modalInstance.close();
            };

            $scope.saveAndClose = function () {
                if ($scope.isChanged) {
                    $q.all([updateSortOrderProcessItems(), updateSortOrderHandbookItems()]).then(function () {
                        closeAndUpdateFavoriteTree();
                    });
                }
                else {
                    $modalInstance.close();
                }
            };

            function updateSortOrderHandbookItems() {
                var documents = reArrangeAndGetChangedSortOrderItems($scope.documents, $scope.originalDocumentsData);
                var folders = reArrangeAndGetChangedSortOrderItems($scope.folders, $scope.originalFoldersData);
                var updatedItems = documents.concat(folders);
                return $http.post(handbookRequests.UpdateFavoritesSortOrder, updatedItems)
                    .then(function () {
                        $scope.isChanged = false;
                        updateOriginalData();
                    });
            }

            function updateSortOrderProcessItems() {
                if ($scope.enableProcessModule) {
                    var originalAreas = angular.copy($scope.areas);
                    var originalProcesses = angular.copy($scope.processes);
                    var areas = reArrangeAndGetChangedSortOrderItems($scope.areas, originalAreas);
                    var processes = reArrangeAndGetChangedSortOrderItems($scope.processes, originalProcesses);
                    var params = {
                        areas: areas,
                        processes: processes
                    };
                    return $http.post("/api/ProcessAreas/UpdateFavoritesSortOrder", params)
                        .success(function (data, status, headers, config) {
                            if (data) {
                                pubSub.publish(broadcastType.updateFavoritesProcesses, true);
                            }
                        });
                }
            }

            function initDataSource() {
                for (var index = 0; index < items.length; index++) {
                    if (isFolder(items[index].type)) {
                        if (!items[index].isForced && items[index].type != E.nodeTypes.DepartmentFolder) {
                            $scope.folders.splice(index, 0, items[index]);
                            $scope.originalFoldersData.splice(index, 0, angular.copy(items[index]));
                        }
                        else {
                            $scope.forcedAndDepartmentFolders.splice(index, 0, items[index]);
                        }
                    }
                    else {
                        $scope.documents.splice(index, 0, items[index]);
                        $scope.originalDocumentsData.splice(index, 0, angular.copy(items[index]));
                    }

                    if (items[index].sort > 0) {
                        $scope.isSortByAlphabet = false;
                    }
                }
                loadProcessAndAreas();
            }

            function loadProcessAndAreas() {
                $http.get(handbookRequests.GetFavoritesItemsExcludeForcedFavoriteRequest)
                    .success(function (data, status, headers, config) {
                        if (data) {
                            decorateNodes(data.areas, data.processes);
                            $scope.areas = data.areas;
                            $scope.processes = data.processes;
                            var existedSort = $scope.areas.some(function (item) { return item.sort > 0; }) || $scope.processes.some(function (item) { return item.sort > 0; });
                            if (existedSort) {
                                $scope.isSortByAlphabet = false;
                            }
                        }
                    });
            }

            function decorateNodes(areas, processes) {
                if (areas && areas.length > 0) {
                    for (var i = 0; i < areas.length; i++) {
                        areas[i].type = 0;
                    }
                }
                if (processes && processes.length > 0) {
                    for (var i = 0; i < processes.length; i++) {
                        processes[i].type = 1;
                        processes[i].id = processes[i].processNumber;
                    }
                }
            }

            function isFolder(type) {
                return type > E.nodeTypes.ShortcutDocument;
            }

            function confirmAndDeleteItem(object, requestUrl, dataSource, originalDataSource, isUpdateFavoriteTree, params) {
                var modalInstance = $uibModal.open({
                    templateUrl: paths.ConfirmationView,
                    controller: controllers.confirmController,
                    resolve: {
                        item: function () {
                            return object.name;
                        }
                    }
                });

                modalInstance.result.then(function (isConfirm) {
                    if (isConfirm) {
                        $http.post(requestUrl, params)
                             .then(function () {
                                 //remove item in manage window
                                 dataSource.splice($.inArray(object, dataSource), 1);

                                 //remove item in original data
                                 if (originalDataSource != null) {
                                     removeItemFromList(object.id, originalDataSource);
                                 }
                                 //remove item in favorite tree
                                 if (isUpdateFavoriteTree) {
                                     broadcastToUpdateFavoriteTree(object);
                                     if ($scope.enableProcessModule) {
                                         pubSub.publish(broadcastType.updateFavoritesProcesses, true);
                                     }
                                 }
                             });
                    }
                });
            }

            function removeItemFromList(id, dataSource) {
                for (var index = 0; index < dataSource.length; index++) {
                    if (dataSource[index].id == id) {
                        dataSource.splice(index, 1);
                        break;
                    }
                }
            }

            function removeOldActiveDragItem() {
                var oldActive = angular.element.find(elementClass.currentDrag);
                if (oldActive.length > 0) {
                    oldActive.forEach(function (element) {
                        var css = element.className.replace(' ' + cssClass.currentDrag, '');
                        element.className = css;
                    });
                }
            }

            function broadcastToUpdateFavoriteTree(item) {
                var target = {
                    data: {
                        id: item.id,
                        name: item.name,
                        type: item.type,
                        isDocument: !isFolder(item.type)
                    },
                    requestType: requestType.removeRequest
                };
                broadcastService(broadcastType.favoriteTarget, target);
            }

            function removeBorderAndUpdateOrder(index, element, object, dataSource, isTop, isBottom) {
                element.removeClass(cssClass.dragEnter);
                if (isTop || isBottom) {
                    removeItemFromList(object.id, dataSource);
                    if (isTop) {
                        dataSource.splice(0, 0, object);
                    }
                    else {
                        dataSource.splice(dataSource.length, 0, object);
                    }
                }
                else {
                    var moveObjectIndex = dataSource.indexOf(object);
                    if (index != moveObjectIndex) {
                        removeItemFromList(object.id, dataSource);
                    }
                    if (index > moveObjectIndex) {
                        dataSource.splice(index, 0, object); //move down
                    }
                    if (index < moveObjectIndex) {
                        dataSource.splice(index + 1, 0, object); //move up
                    }
                }
                $scope.runOnce = true;
                removeOldActiveDragItem();
            }

            function getSourceByItemType(type) {
                if (isFolder(type)) {
                    return $scope.folders;
                } else {
                    return $scope.documents;
                }
            }

            function getSourceProcessAreasByItemType(type) {
                return type == 0 ? $scope.areas : $scope.processes;
            }

            function getSourceByCurrentTab(isOriginalSource) {
                switch ($scope.currentTab) {
                    case manageFavoriteTabs.folder:
                        if (isOriginalSource) {
                            return $scope.originalFoldersData;
                        }
                        else {
                            return $scope.folders;
                        }
                    case manageFavoriteTabs.document:
                        if (isOriginalSource) {
                            return $scope.originalDocumentsData;
                        }
                        else {
                            return $scope.documents;
                        }
                    case manageFavoriteTabs.processArea:
                        return $scope.areas;

                    case manageFavoriteTabs.process:
                        return $scope.processes;

                    default:
                        return $scope.folders;
                }
            }

            function reArrangeAndGetChangedSortOrderItems(dataSource, originalDataSource) {
                var changedItems = [];
                for (var index = 0; index < dataSource.length; index++) {
                    dataSource[index].sort = index;
                    if (dataSource[index].sort != originalDataSource[index].sort || dataSource[index].id != originalDataSource[index].id) {
                        changedItems.splice(changedItems.length, 0, dataSource[index]);
                    }
                }
                return changedItems;
            }

            function setOrderByAlphabet(dataSource) {
                dataSource.sort(function (item1, item2) {
                    if (item1.name.toLowerCase() > item2.name.toLowerCase())
                        return 1;
                    else
                        return -1;
                    return 0;
                });
                for (var index = 0; index < dataSource.length; index++) {
                    dataSource[index].sort = 0;
                }
            }

            function closeAndUpdateFavoriteTree() {
                var source = $scope.documents.concat($scope.folders).concat($scope.forcedAndDepartmentFolders);
                $modalInstance.close(source);
            }

            function updateOriginalData() {
                $scope.originalFoldersData = angular.copy($scope.folders);
                $scope.originalDocumentsData = angular.copy($scope.documents);
            }

        }]);

    model.controller(controllers.confirmController, ['$scope', 'item', '$uibModalInstance', function ($scope, item, $modalInstance) {
        $scope.translation = globalResources;
        $scope.confirmMessage = String.format(globalResources.DeleteConfirmMessage, '"' + item + '"');

        $scope.confirm = function () {
            $modalInstance.close(true);
        };

        $scope.cancel = function () {
            $modalInstance.close(false);
        };

    }]);

})();